var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "list", staticClass: "xinfang-list" },
    [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c("svgicon", {
            attrs: {
              name: "search",
              width: ".38rem",
              height: ".38rem",
              color: "#9fa2a3",
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.title,
                expression: "title",
              },
            ],
            staticClass: "search-input",
            attrs: { type: "text", placeholder: "输入小区或商圈开始找房咯~" },
            domProps: { value: _vm.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.title = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "search-btn" }, [_vm._v("搜索")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter" },
        _vm._l(_vm.currentFilterList, function (item) {
          return _c(
            "div",
            {
              staticClass: "filter-item",
              style: { color: item.statu ? "#00ae66" : "#999" },
              on: {
                click: function () {
                  _vm.isShowFilter = true
                  _vm.filterType = item.type
                },
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(item.value || item.title) + "\n       "
              ),
              _c("svgicon", {
                staticClass: "filter-icon",
                attrs: {
                  name: "triangle",
                  width: ".2rem",
                  height: ".2rem",
                  color: item.statu ? "#00ae66" : "#999",
                  dir: item.statu ? "left" : "",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("my-filter", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowFilter,
            expression: "isShowFilter",
          },
        ],
        attrs: {
          filter: _vm.filter,
          houseType: _vm.type,
          type: _vm.filterType,
        },
        on: { change: _vm.changeFilter },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        _vm._l(_vm.list, function (house, index) {
          return _c("house", {
            key: index,
            attrs: { house: house, type: _vm.type },
            on: { handleHosue: _vm.handleHosue },
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.loadMore.scrollStatu != "hide"
        ? _c("div", { ref: "scrollWrapperTip", staticClass: "loadmore-tip" }, [
            _c("span", { staticClass: "text-loadmore" }, [
              _vm._v(
                _vm._s(_vm._f("scrollTextFilter")(_vm.loadMore.scrollStatu))
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.list.length == 0
        ? _c("div", { staticClass: "wrapper-null" }, [
            _vm._v(_vm._s(_vm.nullString)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "btn-go-top", on: { click: _vm.goToTop } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }